var tracks = [
    { name: 'levelup', track: null, filename: './music/levelup.ogg' },
    { name: 'track1', track: null, filename: './music/Track1.ogg' },
    { name: 'slime forest', track: null, filename: './music/SlimeForest.ogg' },
    { name: 'dark cavern', track: null, filename: './music/DarkCavern.ogg' },
]

function getTracks() {
    return tracks
}

var musicVolume = 0.015


function setMusicVolume(v) {
    try {
        v = v < 0 ? 0 : v
        v = v > 1 ? 1 : v
        for (let t in tracks) {
            tracks[t].track.volume = v
            musicVolume = v
        }
    } catch (e) {
        console.log('Error in setMusicVolume:', e)
    }
}

function getTrack(name) {
    try {
        let img = tracks.filter(f => f.name === name)
        return img.length > 0 ? img[0].track : null
    } catch (e) {
        console.log('Error in getTrack', e)
    }
}

function playTrack(name, onEnded) {
    try {
        let sf = tracks.filter(f => f.name === name)
    
        if (sf.length > 0 && !isTrackPlaying(name)) {
            sf[0].track.volume = musicVolume
            sf[0].track.currentTime = 0
            sf[0].track.loop = true
            sf[0].track.onended = () => {
                if (onEnded) {
                    onEnded(sf[0])
                }
            }
            sf[0].track.play().catch((e) => console.log(e))
        }
    } catch (e) {
        console.log('Error playing track', name, e)
    }
}

function resumeTrack(name, onEnded) {
    try {
        let sf = tracks.filter(f => f.name === name)
        if (sf.length > 0) {
            sf[0].track.volume = musicVolume
            sf[0].track.loop = true
            sf[0].track.onended = () => {
                if (onEnded) {
                    onEnded(sf[0])
                }
            }
            sf[0].track.play().catch((e) => console.log(e))
        }
    } catch (e) {
        console.log('Error resuming track', name, e)
    }
}

function pauseTrack(name) {
    try {
        let sf = tracks.filter(f => f.name === name)
        if (sf.length > 0) {
            sf[0].track.pause()
        }
    } catch (e) {
        console.log('Error pausing track', name, e)
    }
}

function stopTrack(name) {
    try {
        let sf = tracks.filter(f => f.name === name)
        if (sf.length > 0) {
            sf[0].track.pause()
            sf[0].track.currentTime = 0
        }
    } catch (e) {
        console.log('Error stopping track', name, e)
    }
}

function isTrackPlaying(name) {
    let sf = getTrack(name)
    if (sf) {
        return !sf.paused || sf.currentTime && sf.currentTime < sf.duration
    }
    return false
}

// function isTrackPlaying(name) {
//     try {
//         let sf = tracks.filter(f => f.name === name)
//         if (sf.length > 0) {
//             console.log('isTrackPlaying', name, sf[0], sf[0].track.paused)            
//             return !sf[0].track.paused
//         }
//     } catch (e) {
//         console.log('Error in isTrackPlaying():', e)
//     }
// }

function loadTrack(filename) {
    return new Promise((resolve, reject) => {
        try {
            let sf = new Audio(filename)
            sf.oncanplaythrough = (e) => {
                sf.loop = true
                resolve(sf)
            }
            sf.onerror = (e) => {
                console.error(`Failed to load file ${filename}:`, e)
                reject(`Failed to load file ${filename}:`, e)
            }
        } catch (e) {
            console.log('Error in loadTrack', e)
        }
    })
}

function loadMusic() {
    let promises = []
    for (let i in tracks) {
        let track = tracks[i]
        promises.push(new Promise((resolve, reject) => loadTrack(track.filename).then(r => {
            track.track = r
            resolve(r)
        }).catch(e => {
            console.error('Failed to load', track.filename, e)
            reject('Failed to load ' + track.filename + '.')
        })))
    }
    return Promise.allSettled(promises)
}

export { loadMusic, loadTrack, isTrackPlaying, playTrack, getTrack, setMusicVolume, pauseTrack, getTracks, stopTrack, resumeTrack }